// Autogenerated file
export const syncSystemTrackingTypesEnum = {
    NoTracking: "NoTracking",
    AllChanges: "AllChanges",
    Forwarding: "Forwarding",
};
export const syncSystemTrackingTypes = [
    { label: "Без изменений", value: "NoTracking" },
    { label: "Все изменения", value: "AllChanges" },
    { label: "Изменения для Экспедиции", value: "Forwarding" },
];
